import type { InfiniteData } from '@tanstack/react-query';
import type { FetchLeaderboardParams, LeaderboardResponse } from '@/lib/network';
import { useFetchLeaderboard, type UseFetchLeaderboardOptions } from './useFetchLeaderboard';

/**
 * Infinite-scrolling leaderboard query, keyed by `offset`/`limit` (see
 * `useFetchLeaderboard` for the paging mechanics). Any page that needs a
 * leaderboard with infinite scroll — e.g. League Detail's standings table —
 * should call this rather than re-implementing pagination.
 */
export const useLeaderboardInfiniteQuery = <TData = InfiniteData<LeaderboardResponse>>(
  params: Omit<FetchLeaderboardParams, 'offset'> | null,
  options?: UseFetchLeaderboardOptions<TData>
) => useFetchLeaderboard<TData>(params, options);
